import React from 'react';
import PropTypes from 'prop-types';
import { Card, CardContent, Typography, Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import { useHistory } from 'react-router-dom';

export default function HealthProfileCard(props) {
  const history = useHistory();
  const useStyles = makeStyles({
    root: {
      '&:hover': {
        cursor: 'pointer',
      },
    },
  });

  const classes = useStyles();

  return (
    <div style={{ marginRight: '7px', marginBottom: '7px' }}>
      <Card
        className={classes.root}
        onClick={() => {
          history.push({
            pathname: `/${props.redirectPath}`,
            state: {
              editMode: true,
              editStep: props.redirectStep,
            },
          });
        }}
      >
        <CardContent>
          <Grid container direction="row">
            <Grid
              item
              xs={props.illustration ? 6 : 12}
              style={{ paddingRight: props.illustration ? '10px' : '20px' }}
            >
              <Grid container direction="column">
                <Grid item xs={12}>
                  <Typography variant={'body1'} style={{ fontSize: '14px' }}>
                    {props.title}
                  </Typography>
                </Grid>
                <Grid item xs={12} style={{ marginTop: '20px' }}>
                  <Typography
                    variant={'body1'}
                    style={{ color: props.valueColor }}
                  >
                    {props.value}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
            {props.illustration && (
              <Grid item xs={6}>
                <Grid
                  container
                  direction="row"
                  justify="flex-end"
                  alignItems="flex-end"
                >
                  <Grid item style={{ marginRight: '20px' }}>
                    {props.illustration ? props.illustration : <div />}
                  </Grid>
                </Grid>
              </Grid>
            )}
            <Grid item xs={12} style={{ marginTop: '-25px' }}>
              <Grid
                container
                direction="row"
                justify="flex-end"
                alignItems="flex-start"
              >
                <Grid item>
                  <NavigateNextIcon style={{ color: props.valueColor }} />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </div>
  );
}

HealthProfileCard.propTypes = {
  title: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  valueColor: PropTypes.string.isRequired,
  icon: PropTypes.object.isRequired,
};
